import React from "react";

const BlogDetailsContaints = ({ content }) => {
  return (
    <div className="w-full px-4 md:px-10 pt-6 max-w-4xl">
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed whitespace-pre-line">
        {content}
      </p>
    </div>
  );
};

export default BlogDetailsContaints;
